import { BelgeDto, EtrangerDto, FormeJuridiqueDto, PersonneMoraleDto, PersonnePhysiqueDto, PlaquePersonnePhysiqueDto, SecondeResidenceDto, TypeDechetDto } from "src/api/models";

export namespace Visiteurs {
  export class DeleteFormeJuridique {
    static readonly type = '[Visiteurs] Delete forme juridique';
    constructor(public fj: FormeJuridiqueDto) {}
  }

  // Personne physique
  export class DesactivatePP {
    static readonly type = '[Visiteurs] Desactivate personne physique';
    constructor(public personnePhysique: PersonnePhysiqueDto) {}
  }

  export class ExcludePP {
    static readonly type = '[Visiteurs] Exclude personne physique';
    constructor(public personnePhysique: PersonnePhysiqueDto) {}
  }

  export class GetPPDetail {
    static readonly type = '[Visiteurs] Get personne physique detail';
    constructor(public personnePhysiqueId: number) { }
  }

  export class GetBelgeDetail {
    static readonly type = '[Visiteurs] Get belge detail';
    constructor(public personnePhysiqueId: number) { }
  }

  export class GetEtrangerDetail {
    static readonly type = '[Visiteurs] Get etranger detail';
    constructor(public personnePhysiqueId: number) { }
  }

  export class UpdatePPDetail {
    static readonly type = '[Visiteurs] Update personne physique detail';
    constructor(public personnePhysique: PersonnePhysiqueDto) { }
  }

  export class CreateEtrangerCodes {
    static readonly type = '[Visiteurs] Create etranger codes';
    constructor(public etrangerId: number) {}
  }

  export class CreateBelge {
    static readonly type = '[Visiteurs] Create belge';
    constructor(public belge: BelgeDto) {}
  }

  export class IsAlreadyExistBelge {
    static readonly type = '[Visiteurs] Is already exist belge';
    constructor(public nom: string, public prenom: string, public dateDeNaissance: string) {}
  }

  export class IsAlreadyExistEtranger {
    static readonly type = '[Visiteurs] Is already exist etranger';
    constructor(public nom: string, public prenom: string, public dateDeNaissance: string) {}
  }

  export class CreateEtranger {
    static readonly type = '[Visiteurs] Create etranger';
    constructor(public etranger: EtrangerDto) {}
  }

  // Personne morale
  export class DesactivatePM {
    static readonly type = '[Visiteurs] Desactivate personne morale';
    constructor(public personneMorale: PersonneMoraleDto) {}
  }

  export class GetPMDetail {
    static readonly type = '[Visiteurs] Get personne morale detail';
    constructor(public personneMoraleId: number) { }
  }

  export class UpdatePMDetail {
    static readonly type = '[Visiteurs] Update personne morale detail';
    constructor(public personneMorale: PersonneMoraleDto) { }
  }

  export class CreatePM {
    static readonly type = '[Visiteurs] Create personne morale';
    constructor(public personneMorale: PersonneMoraleDto) { }
  }

  export class CreatePMCodes {
    static readonly type = '[Visiteurs] Create personne morale codes';
    constructor(public personneMoraleId: number) { }
  }

  // Seconde résidence
  export class GetSecondeResidenceDetail {
    static readonly type = '[SecondeResidence] Get seconde residence detail';
    constructor(public secondeResidenceId: number) { }
  }

  export class UpdateSecondeResidenceDetail {
    static readonly type = '[SecondeResidence] Update seconde residence detail';
    constructor(public secondeResidence: SecondeResidenceDto) { }
  }

  export class AddSecondResidencePersonne {
    static readonly type = '[SecondeResidence] Add person to second residence';
    constructor(public personneId: number, public secondeResidence: SecondeResidenceDto) { }
  }

  export class GetTypesDechets {
    static readonly type = '[TypeAcces] Get type dechets';
  }

  export class CreateDemandeQuotaPP {
    static readonly type = '[DemandeQuota] Demande quota PP';
    constructor(public personnePhysiqueId: number) {}
  }

  export class CreateDemandeQuotaPM {
    static readonly type = '[DemandeQuota] Demande quota PM';
    constructor(public personneMoraleId: number) {}
  }

  // Plaques personnes physiques
  export class DesactivatePlaquePP {
    static readonly type = '[Visiteurs] Desactivate plaque personne physique';
    constructor(public plaquePersonnePhysique: PlaquePersonnePhysiqueDto) {}
  }

  export class GetPlaquePPDetail{
    static readonly type = '[Visiteurs] Get plaque personne physique detail';
    constructor(public plaquePersonnePhysiqueId: number) { }
  }

  export class UpdatePlaquePPDetail {
    static readonly type = '[Visiteurs] Update plaque personne physique detail';
    constructor(public plaquePersonnePhysique: PlaquePersonnePhysiqueDto) { }
  }

  export class CreatePlaquePP {
    static readonly type = '[Visiteurs] Create plaque personne physique';
    constructor(public plaquePersonnePhysique: PlaquePersonnePhysiqueDto) { }
  }

  export class IsAlreadyExistPlaque{
    static readonly type = '[Visiteurs] Is already exist plaque personne physique';
    constructor(public plaque: string) { } 
  }

}
